module.exports = __webpack_public_path__ + "img/frame (140).7f59e88f.jpg";